import React, { useState,useEffect } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import Chip from '@material-ui/core/Chip'
import InfoIcon from '@material-ui/icons/Info'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import TimerIcon from '@material-ui/icons/Timer'
import { useStyles } from './DialogValidationStyle'

import allActions from '../../../redux/actions/user'
import { useDispatch,useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import PaiementModal from '../../../components/paiement/PaiementModal'
import CountDown from '../../paiement/CountDown'


export default function AlertDialog(props) {
  
  const [codeAdherent, setcodeAdherent] = useState({ code:'',label:'' })
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const state = useSelector(state => state)
  const [currentResId, setcurrentResId] = useState('')
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''
  const classes = useStyles()

  const setInvite = () => {
    setcodeAdherent({ code : '99999999', label:'INVITE' })
  }
  
  useEffect(() => {
    if(props.status === 'MODIFICATION')
    {
      if(props.guestName === '99999999')
        setcodeAdherent({ code:'99999999',label:'INVITE' })
      else
        setcodeAdherent({ code:props.codeAdherent,label:props.codeAdherent })
    }
  }, [])
  
  const handleClose = () => {
    props.close(false)
    props.setmove(false)
  }
  
  
  //Faire une reservation
  const moveReservation = async () =>{
    props.setmove(true)
    props.setoldReservation({
      ownerId:props.ownerId,
      guestId2:props.guestId2,
      rescre_id:props.rescre_id,
      res_id:props.res_id,
      date:props.date
    })
    props.close(false)
  }
  
  
  //Faire une reservation
  const checkDisponibility = () =>{
      
    return new Promise( async(res) => {
      let body = {
        userNumero : state.user.numero,
        guestNumero : codeAdherent.code,
        cntId: props.centreId,
        // guestNumero : '99999997'
      }
      var result = await allActions.fetchPostAPI(`api/reservation/centres/checkReservation/${props.rescre_id}/${props.date.toISOString().split('T')[0]}`,body,dispatch, token)
     
      if(result.json.variant === 'success')
      {
        // Si invité on pré réserve le crénaux avant de payer
        if (codeAdherent.code === '99999999'){
          const result2 = await allActions.fetchPostAPI(`api/reservation/centres/prereservations/${props.rescre_id}/${props.date.toISOString().split('T')[0]}/null`,body,dispatch, token)
          setcurrentResId(result2.json.data.recordset[0].RES_ID)
          enqueueSnackbar(`${result.json.message}`, { variant: result.json.variant })
        }
      }
      res ({ message : result.json.message, variant: result.json.variant })
    })
  }

    
  //Faire une reservation
  const doReservation = async (additionalInfos) =>{
    if(codeAdherent.code)
    {
      let body = {
        userNumero : state.user.numero,
        guestNumero : codeAdherent.code,
        additionalInfos: additionalInfos,
        cntId: props.centreId,
      }
      const result = await allActions.fetchPostAPI(`api/reservation/centres/reservations/${props.rescre_id}/${props.date.toISOString().split('T')[0]}/null`,body,dispatch, token)
      enqueueSnackbar(`${result.json.message}`, { variant: result.json.variant })
      props.reload()
      handleClose()
    }
    else
      enqueueSnackbar(`Numéro adhérent vide`, { variant: 'error' })
  }
  
  //Update un reservation
  const updateReservation = async () =>{
    let body = {
      userId : state.user.id,
      guestNumero: codeAdherent.code,
    }
    const result = await allActions.fetchPostAPI(`api/reservation/centres/reservations/update/${props.res_id}/${props.date.toISOString().split('T')[0]}`,body,dispatch, token)
    enqueueSnackbar(`${result.json.message}`, { variant: result.json.variant })
    props.reload()
    handleClose()
  }
  
  
  //Delete une réservation
  const deleteReservation = async (res_id) => {
    var body = {
      userId : state.user.id,
      ownerId :state.user.id,
    }
    const result = await allActions.fetchDeleteAPI(`api/reservation/centres/reservations/${currentResId}`,body,dispatch, token)
  }
  
  const actionPayement = (etat) => {
    if(etat) doReservation(etat)
  }

  const userInfo =  {
    userNumero : state.user.numero,
    guestNumero : codeAdherent.code,
    rescre_id : props.rescre_id,
    res : props.ownerId,
    date : props.date.toISOString().split('T')[0]
  }
  
  
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { margin: 16 } }}
      >
        <DialogTitle id="alert-dialog-title">{props.titre}</DialogTitle>
        
        <DialogContent>
          <div className={classes.info}>
            <Chip avatar={<InfoIcon/>} label={'Court '+props.court} variant="outlined" />
            <Chip avatar={<EventAvailableIcon/>} label={props.date.toLocaleDateString()} variant="outlined" />
            <Chip avatar={<TimerIcon/>} label={props.creneau} variant="outlined" />
          </div>
          <p>Numéro d'adhérent de votre partenaire :</p>
          <form className={classes.form}>
            <TextField
              id="standard-basic"
              label="Numéro d'adhérent"
              value={codeAdherent.label}
              onChange={(e)=>setcodeAdherent({ code:e.target.value,label:e.target.value })}
              margin="dense"
              variant="outlined"
              fullWidth
            />
            <Button color="primary" onClick={() => setInvite()} >INVITER</Button>          
          </form> 
  
  
        </DialogContent>
  
        <DialogActions>
  
          {props.status == 'MODIFIABLE' ? 
            <>
              <Button style={{ color:'red' }} onClick={moveReservation} color="primary">
                Déplacer
              </Button>
              <Button onClick={updateReservation}  color="primary" disabled={!codeAdherent.label}>
                MODIFIER
              </Button> 
            </>: 
            <PaiementModal onClose={handleClose} amount="1000" deleteReservation={deleteReservation} callback={actionPayement} callbackModal={checkDisponibility} userInfo={userInfo} codeAdherent={codeAdherent.code} doReservation={doReservation} />
          }
          <Button style={{ color:'grey' }}  onClick={handleClose} color="primary">Annuler</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
